import { jsx as _jsx } from "react/jsx-runtime";
export default function ArrowUpWithTail(_a) {
    var _b = _a.className, className = _b === void 0 ? "fill-[#1BC5BD]" : _b;
    return (_jsx("svg", { width: "10", height: "14", viewBox: "0 0 10 14", className: className, xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M0.333374 5.00008L1.27337 5.94008L4.33337 2.88675L4.33337 13.6667L5.66671 13.6667L5.66671 2.88675L8.72671 5.94675L9.66671 5.00008L5.00004 0.333416L0.333374 5.00008Z" }) }));
}
